import { render, staticRenderFns } from "./PartnerCompany.vue?vue&type=template&id=9b4250f4"
import script from "./PartnerCompany.vue?vue&type=script&lang=js"
export * from "./PartnerCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b4250f4')) {
      api.createRecord('9b4250f4', component.options)
    } else {
      api.reload('9b4250f4', component.options)
    }
    module.hot.accept("./PartnerCompany.vue?vue&type=template&id=9b4250f4", function () {
      api.rerender('9b4250f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/PartnerCompany.vue"
export default component.exports